"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
let EditCookieRemarkDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.cookie_id = "";
    this.remark_data = "";
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  open(row) {
    return __async(this, null, function* () {
      this.cookie_id = row.id;
      this.remark_data = row.remark;
      this.dialog.visible = true;
    });
  }
  cancel() {
    this.dialog.visible = false;
    this.remark_data = "";
  }
  editRemark() {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.auth/api/v8/cookies-backup/${this.cookie_id}`, {
          "model": "cookie.backup.remark.edit",
          "remark": this.remark_data
        });
        this.$message.success(this.$t("edit_cookie_remark_dialog.edit_remark_success"));
        this.cancel();
        this.$emit("refreshCookie");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
EditCookieRemarkDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], EditCookieRemarkDialog);
export {
  EditCookieRemarkDialog as default
};
